import Box from '@mui/material/Box';
import { Form, SelectInput, useCreate } from 'react-admin';
import { CHANGE_NODE_BY_HUMAN_ID } from '@/utils/CONST';

interface Props {
    currentNode: any;
    avatarUriId: string;
    choices: {
        id: string;
        name: string;
        disabled?: boolean;
    }[];
    callback?: any;
    disabled?: boolean;
}

const ChangeStatusField = ({ currentNode, avatarUriId, choices, callback, disabled = false }: Props) => {
    const [create, { isLoading: isLoadingCreate }] = useCreate();

    const handleChangeNode = ({ target: { value: humanId } }: any) => {
        create(
            CHANGE_NODE_BY_HUMAN_ID,
            {
                data: {
                    avatar: avatarUriId,
                    humanId,
                    extraData: [],
                },
                meta: {
                    api: 'v2',
                },
            },
            {
                onSuccess: () => {
                    if (callback) callback(humanId);
                },
            },
        );
    };

    return (
        <Box onClick={(e: any) => e.stopPropagation()}>
            <Form
                defaultValues={{
                    idForNodeHumanReadable: currentNode?.configuration?.idForNodeHumanReadable,
                }}
            >
                <SelectInput
                    onChange={handleChangeNode}
                    isRequired
                    emptyValue={false}
                    source='idForNodeHumanReadable'
                    choices={choices}
                    helperText={false}
                    label={'disorder.actions.change_status.select_label'}
                    disabled={disabled || isLoadingCreate}
                    size='small'
                />
            </Form>
        </Box>
    );
};

export default ChangeStatusField;
